import { render, staticRenderFns } from "./time-config.vue?vue&type=template&id=2efde34b&scoped=true&"
import script from "./time-config.vue?vue&type=script&lang=js&"
export * from "./time-config.vue?vue&type=script&lang=js&"
import style0 from "./time-config.vue?vue&type=style&index=0&id=2efde34b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efde34b",
  null
  
)

export default component.exports